import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../context/ThemeContext';

const { FiSun, FiMoon, FiMonitor } = FiIcons;

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const themes = [
    { name: 'light', icon: FiSun, label: 'Claro' },
    { name: 'system', icon: FiMonitor, label: 'Sistema' },
    { name: 'dark', icon: FiMoon, label: 'Oscuro' }
  ];

  return (
    <div className="flex items-center bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
      {themes.map((themeOption) => (
        <motion.button
          key={themeOption.name}
          onClick={() => setTheme(themeOption.name)}
          className={`p-2 rounded-md transition-colors duration-200 ${
            theme === themeOption.name
              ? 'bg-indigo-600 text-white shadow-md'
              : 'text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          title={themeOption.label}
        >
          <SafeIcon icon={themeOption.icon} className="w-4 h-4" />
        </motion.button>
      ))}
    </div>
  );
};

export default ThemeToggle;